export default "__VITE_ASSET__bj_IZBS2__"